"use client";

import { useInfront } from "@/context/infront-context";
import { useEffect, useRef } from "react";

const ID = "instrument-overview";

type InstrumentOverviewProps = {
  instrument: { feed: number; ticker: string };
};

const InstrumentOverview = (props: InstrumentOverviewProps) => {
  const { isReady, load } = useInfront();
  const widgetsRef = useRef<any[]>([]);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(() => {
      if (!isReady || !active) return;

      widgetsRef.current.forEach((w) => w?.destroy());
      widgetsRef.current = [];

      const widgetOptions =
        new window.Infront.InstrumentSingleValueWidgetOptions();

      widgetOptions.instrument = props.instrument;

      const setup = (name: string, elId: string) => {
        widgetOptions.name = name;
        widgetsRef.current.push(
          window.infront.instrumentSingleValueWidget(`#${elId}`, widgetOptions)
        );
      };

      setup("FULL_NAME",      `${ID}-full-name`);
      setup("PCT_CHANGE",     `${ID}-change`);
      setup("LAST",           `${ID}-last`);
      setup("HIGH",           `${ID}-high`);
      setup("LOW",            `${ID}-low`);
      setup("OPEN",           `${ID}-open`);
      setup("PREVIOUS_CLOSE", `${ID}-close`);
    });

    return () => {
      active = false;
      widgetsRef.current.forEach((w) => w?.destroy());
      widgetsRef.current = [];
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady, props.instrument.feed, props.instrument.ticker]);

  return (
    <div className="card">
      <div
        className="text-2xl font-bold flex items-center"
        id={`${ID}-full-name`}
      />

      <div className="flex space-x-4 items-center">
        <div>{props.instrument.ticker}</div>
        <div id={`${ID}-last`} />
        <div id={`${ID}-change`} />
      </div>

      <div className="text-2xl font-bold flex items-center" id={`${ID}-last`} />

      <div className="flex justify-between mt-4">
        <div className="flex space-x-4">
          <div>
            <div className="font-bold text-sm">Lägst</div>
            <div id={`${ID}-low`} />
          </div>

          <div>
            <div className="font-bold text-sm">Högst</div>
            <div id={`${ID}-high`} />
          </div>
        </div>

        <div className="flex space-x-4 mt-0">
          <div>
            <div className="font-bold text-sm">Föreg. stäng.</div>
            <div id={`${ID}-close`} />
          </div>

          <div>
            <div className="font-bold text-sm">Öppning</div>
            <div id={`${ID}-open`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstrumentOverview;
